export default "__VITE_ASSET__DubI8$QI__"